// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#topBar[data-v-6b55525d]{background:#333;color:#fff;line-height:40px}#topBar .bar-item[data-v-6b55525d]{position:relative}#topBar .bar-item[data-v-6b55525d]:not(:first-child):before{border-left:1px solid #fff;content:\"\";height:1em;left:0;position:absolute;top:50%;transform:translateY(-50%)}#mainHeader[data-v-6b55525d]{align-items:center;display:flex;height:120px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
